import axios from "axios";

export const SETTINGS_URL = "/settings";

// CREATE =>  POST: add a new webhook url
export function addWebhook(webhookData) {
  return axios.post(`${SETTINGS_URL}/webhook`, {...webhookData});
}

// READ
export function getAllWebhooks() {
  return axios.get(`${SETTINGS_URL}/webhook`);
}

// UPDATE => PUT: update the webhook on the server
export function updateWebhook(webhookData) {
  return axios.patch(`${SETTINGS_URL}/webhook`, { ...webhookData });
}

// DELETE => delete the webhook from the server
export function deleteWebhook(webhookId) {
  return axios.delete(`${SETTINGS_URL}/webhook/${webhookId}`);
}

